"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Signal = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Signal = function Signal() {
  return react_1.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 4.69922C19.5523 4.69922 20 5.14693 20 5.69922V19.6992C20 20.2515 19.5523 20.6992 19 20.6992H17C16.4477 20.6992 16 20.2515 16 19.6992V5.69922C16 5.14693 16.4477 4.69922 17 4.69922H19ZM14 19.6992V9.69922C14 9.14693 13.5523 8.69922 13 8.69922H11C10.4477 8.69922 10 9.14693 10 9.69922V19.6992C10 20.2515 10.4477 20.6992 11 20.6992H13C13.5523 20.6992 14 20.2515 14 19.6992ZM7 20.6992H5C4.44772 20.6992 4 20.2515 4 19.6992V13.6992C4 13.1469 4.44772 12.6992 5 12.6992H7C7.55228 12.6992 8 13.1469 8 13.6992V19.6992C8 20.2515 7.55228 20.6992 7 20.6992Z",
    fill: "currentColor"
  });
};

exports.Signal = Signal;